import React from "react";
import type { IconProps } from "./types";

/**
 * A file icon component that displays a document with a folded corner,
 * representing files, documents, or file management functionality.
 * @param props - The component props
 * @param props.className - Optional CSS class name to apply to the SVG element
 * @param props.width - The width of the icon in pixels
 * @param props.height - The height of the icon in pixels
 * @returns A React functional component that renders a file SVG icon
 */
const FileIcon: React.FC<IconProps> = ({ className, width = 41, height = 42 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 41 42"
      fill="none"
      className={className}
      width={width}
      height={height}
    >
      <path
        d="M23.9163 3.91835V11.0498C23.9163 12.0167 23.9163 12.5002 24.1025 12.8695C24.2663 13.1944 24.5277 13.4585 24.8491 13.624C25.2145 13.8122 25.6929 13.8122 26.6497 13.8122H33.706M34.1663 17.2449V29.6962C34.1663 32.597 34.1663 34.0474 33.6077 35.1553C33.1164 36.1299 32.3324 36.9223 31.368 37.4189C30.2717 37.9834 28.8366 37.9834 25.9663 37.9834H15.033C12.1627 37.9834 10.7276 37.9834 9.63131 37.4189C8.66698 36.9223 7.88295 36.1299 7.3916 35.1553C6.83301 34.0474 6.83301 32.597 6.83301 29.6962V11.7404C6.83301 8.83958 6.83301 7.38917 7.3916 6.28121C7.88295 5.30661 8.66698 4.51424 9.63131 4.01766C10.7276 3.45312 12.1627 3.45312 15.033 3.45312H20.5198C21.7733 3.45312 22.4001 3.45312 22.9899 3.59624C23.5128 3.72312 24.0128 3.93239 24.4713 4.21638C24.9885 4.53669 25.4317 4.9846 26.3181 5.88041L31.7646 11.3849C32.651 12.2807 33.0942 12.7286 33.4111 13.2513C33.6921 13.7148 33.8992 14.22 34.0247 14.7485C34.1663 15.3446 34.1663 15.978 34.1663 17.2449Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FileIcon;
